// 403 page (audit T3.1/UI-03). Shown when a non-admin reaches an admin route by
// direct URL — a real "you don't have permission" state, NOT a silent redirect
// (a redirect hides the reason). The nav already hides these routes; this closes
// the direct-URL hole.
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ShieldOff } from 'lucide-react';

export function ForbiddenPage() {
  const { t } = useTranslation('pages');
  const navigate = useNavigate();
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-4 p-8 text-center">
      <ShieldOff size={40} className="text-muted" />
      <div className="text-2xl font-semibold tk-num">403</div>
      <p className="max-w-md text-sm text-muted">{t('forbidden.hint')}</p>
      <button className="tk-btn-primary" onClick={() => navigate('/')}>{t('forbidden.back')}</button>
    </div>
  );
}
